import FooterPrivacy from '../../views/auth/components/baseTemplate/FooterPrivacy';
import { getPermissionsMap } from '../../utils/helpers';
import React from 'react';
import Routes from '../../routes';
import styles from './LegalDashboard.module.scss';
import { TopBar } from '../dashboard/components/topBar';

const LegalDashboard: React.FC = ({ children }) => {
    const permissionsMap: Map<string, Array<string>> = getPermissionsMap();

    return (
        <div className={`${styles['legalDashboard-container']}`}>
            <TopBar routes={Routes} permissionsMap={permissionsMap} />
            <div className={`content ${styles['legalDashboard-content']}`}>
                <div
                    className={`content-view ${styles['legalDashboard-contentView']}`}
                >
                    <div
                        className={`${styles['legalDashboard-childrens-container']}`}
                    >
                        {children}
                    </div>
                    <div className={`${styles['legalDashboard-footer']}`}>
                        <FooterPrivacy />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalDashboard;
